'use client';

import { PropsWithChildren, useState } from 'react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Dialog, useOverlay } from '~/components';
import ApiErrorHandler from '~/services/error/api-error-handler';
import { DEFAULT_ERROR_MESSAGE } from '~/services/error';

type Props = PropsWithChildren<{
  visibleDevtools?: boolean;
}>;

export const RQProvider = ({ children, visibleDevtools = false }: Props) => {
  const overlay = useOverlay();

  const [client] = useState(
    new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          staleTime: 1 * 1000,
        },
        mutations: {
          onError: async (error) => {
            const { reason } = await new ApiErrorHandler(error).getErrorData();

            overlay.open(({ isOpen, close }) => (
              <Dialog
                onClose={() => {
                  close();
                }}
                isOpen={isOpen}
                message={reason ?? DEFAULT_ERROR_MESSAGE.message}
                title={DEFAULT_ERROR_MESSAGE.title}
              />
            ));
          },
        },
      },
    }),
  );

  return (
    <QueryClientProvider client={client}>
      {children}
      {visibleDevtools && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};
